class SecteurModel {

    constructor(data) {
        this.id = data.id || null;
        this.nom = data.nom || null;
        this.type = data.type || null; // 'batiment' ou 'autres'
    }
}

export default SecteurModel;
